import { useEffect, useState } from "react";
import { Input } from "../../../components/inputs/Input";
import { Link } from "../../../components/link/link";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import { TypingText } from "../../../components/TypingText/TypingText";
import {
  _aligeText,
  _colorText,
  _size,
  _sizeHeading,
  _sizeText,
  _style,
} from "../../../core/core";
import "./MainMorda.css";

import FixedMordaImage from "../../../assets/images/FixedMorda.webp";
import MordaImage from "../../../assets/images/morda.webp";
import PreloadImage from "../../../components/PreloadImage/PreloadImage";

export const MainMorda = ({ ...props }) => {
  const [search, setSearch] = useState("");
  useEffect(() => {
    const handleScroll = () => {
      const mainMordaB = document.querySelector(".main-morda-b");
      const fixedMorda = document.querySelector(".fixed-morda");

      if (mainMordaB && fixedMorda) {
        const mainMordaBRect = mainMordaB.getBoundingClientRect();
        if (typeof window !== "undefined") {
          if (window.scrollY > mainMordaBRect.bottom) {
            fixedMorda.classList.add("small");
          } else {
            fixedMorda.classList.remove("small");
          }
        }
      }
    };

    if (typeof window === "undefined") {
      return;
    }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <div className="main-morda ">
        <img className="main-morda-fix" src={MordaImage} />
        <div className="main-morda-b">
          <div className="main-morda-t">
            <TypingText
              texts={[
                "Удобный сервис публикации отзывов",
                "Легко управляйте отзывами бизнеса",
              ]}
              typingSpeed={50}
              pauseTime={10000}
            >
              <Title
                type={_sizeHeading.h2}
                is_h1
                color={_colorText.default}
                alige={_aligeText.center}
              ></Title>
            </TypingText>
            <Text
              aligeText={_aligeText.center}
              color={_colorText.default}
              size={_sizeText.m}
            >
              Ваши конкуренты уже работают с нами, но мы вам ничего не говорили
            </Text>
          </div>
          <div className="main-morda-d">
            <Input
              value={search}
              setValue={setSearch}
              placeholder="Найти в HM"
            ></Input>
            <Link
              link={`/uslugi/?search=${search}`}
              size={_size.M}
              style={_style.secondary}
              isMobileWidth
            >
              Найти
            </Link>
          </div>
        </div>
        <div className="fixed-morda">
          <PreloadImage
            imageSrc={FixedMordaImage}
            alt={`картинка`}
            className={"m-img "}
          ></PreloadImage>
        </div>
      </div>
    </>
  );
};
